export default "__VITE_ASSET__41cf9af5__"